import { defineMessages } from 'react-intl'

const messages = defineMessages({
  signInWithGoogle: {
    id: 'google.continue-with-google',
  },
})

export default messages
